import * as React from 'react';
import parse from 'html-react-parser';


import { Carousel, Button } from 'react-bootstrap';
import { View, rem } from '../libs/WebComponents';
import IconButtonShadow from '../Components/IconButtonShadow';
import { ParsePage } from '../App';
import {nl2br} from '../utils/utils-app';
import { Props } from '../types/types';
import { parsePostContent } from './parsePage';

const AppChapters = (props: Props) => {

   const [sindex, setSIndex] = React.useState(0);
   const [animate, setAnimate] = React.useState(false);

   const handleSelect = (selectedIndex: number) => {
     setSIndex(selectedIndex);
   };
 
   const chapters = props.pages ? props.pages.filter((pageObj)=>(pageObj.props.main_chapter)) : [];

   return (
      <View className={'page'}>
         <View style={{paddingTop:rem(3)}}>
 
            <Carousel className={'carousel-chapters'} activeIndex={sindex} onSelect={handleSelect} pause={false} touch={true} nextIcon={null} prevIcon={null} onSlide={()=>setAnimate(false)} onSlid={()=>setAnimate(true)}>
               {chapters.map((pageObj: ParsePage)=>{
                  return (
                  <Carousel.Item key={pageObj.page.ID}>
                     <View className={'carousel-chapter'}>
                        <View><View className='featured-image animate'>{parse(pageObj.page.featured_img)}</View></View>
                        <View className='carousel-content'>
                           <IconButtonShadow animate={animate?10:null}name={'Number-'+pageObj.props.chapter} size={rem(4)} iconColor={'var(--color-white'} color={'var(--color-purple)'} shadow={'var(--color-green)'} containerStyle={{marginBottom:rem(3)}}/>
                        <h3>{pageObj.page.post_title}</h3>
                        <div>{parsePostContent({content:nl2br(pageObj.page.post_excerpt), firstname:props.firstname, goTo:props.goTo, index:props.index})}</div>
                        </View>
                     </View>
                  </Carousel.Item>
               )})}
            </Carousel>
            <Button onClick={()=>props.goTo(props.index+1)} className={'btn btn-primary align-self-center'} style={{marginTop:rem(3)}}>Aan de slag!</Button>
         </View>
   </View>
   );
}

export default React.memo(AppChapters);

